import { TbFileExport } from "react-icons/tb";
import { AdminTitle } from "../../components/AdminTitle";
import { ExportsContainer } from "./components";
import NewDataTable from "../../components/StyledTableContentRaw";
import { TableBody, TableRow } from "@mui/material";
import { useEffect, useState } from "react";
import { FiltersContainer } from "../Debts/style";
import { FiSearch } from "react-icons/fi";
import { StyledInput } from "../../components/StyledInput";
import { usePagedFiles } from "../../hooks/useExports";
import TableTooltip from "../../components/TableTooltip";



export default function ExportsListing() {

  const headers = [
    { key: 'name', label: 'Nome' },
    { key: 'id', label: 'ID' },
    { key: 'type', label: 'Página' },
    { key: 'status', label: 'Status' },
    { key: 'created_at', label: 'Data de Exportação' },
    { key: 'fileUrl', label: 'Link para Download' },
  ];

  const [order, setOrder] = useState<'desc' | 'asc'>('desc');
  const [orderBy, setOrderBy] = useState('created_at');
  const [page, setPage] = useState(1);
  const [itemsPerPage, _] = useState(100);

  const [nameFilterToShow, setNameFilterToShow] = useState<string | undefined>();
  const [nameFilter, setNameFilter] = useState<string | undefined>();

  const { data, isLoading, error, refetch } = usePagedFiles({
    resultsPerPage: itemsPerPage,
    page: page,
    orderByDirection: order,
    orderBy,
    name: nameFilter
  });

  const handleNameValue = (event: any) => {
    const value = event.target.value;
    setNameFilterToShow(value);

    if (value.length > 3) {
      let debounceTimer;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        setNameFilter(value);
      }, 1000);
    }
  };

  useEffect(() => {
    refetch()
  }, [nameFilter])

  function handleFileStatus(status: string) {
    let statusToShow = ""

    switch (status) {
      case "finished":
        statusToShow = "Gerado"
        break;
      case "generating":
        statusToShow = "Gerando..."
        break;
      case "error":
        statusToShow = "Falha ao gerar"
        break;
      default:
        statusToShow = "Indefinido"
        break;
    }

    return statusToShow
  }

  return (
    <ExportsContainer>
      <AdminTitle
        title="Exportações"
        icon={<TbFileExport style={{ fontSize: '30px' }} />}
      />

      <FiltersContainer>
        <label
          htmlFor=""
          className="inputSearch"
          style={{ gridColumn: 'span 2' }}
        >
          <StyledInput
            placeholder="Buscar por nome"
            value={nameFilterToShow}
            onChange={handleNameValue}
          />
          <span className="debt-filter">
            <FiSearch />
          </span>
        </label>
      </FiltersContainer>

      <NewDataTable
        title="Relatórios"
        heads={headers}
        hasPagination
        data={data?.results}
        order={order}
        setOrder={setOrder}
        orderBy={orderBy}
        setOrderBy={setOrderBy}
        page={Number(data?.currentPage)}
        setPage={setPage}
        itemsPerPage={itemsPerPage}
        nPages={data?.nPages}
        isLoading={isLoading}
        error={error}
        totalItems={data?.total}
        refetch={refetch}
      >
        <TableBody>
          {data &&
            data?.results?.map((each, i) => (
              <TableRow key={each?.id}>
                <td>
                  <TableTooltip
                    text={each.name}
                    tooltipText={each.name}
                  />
                </td>
                <td>{each?.id || '--'}</td>
                <td>{each?.type || '--'}</td>
                <td>{handleFileStatus(each?.status) || '--'}</td>
                <td>
                  {each?.created_at
                    ? new Date(each?.created_at)?.toLocaleDateString()
                    : '--'}
                </td>
                <td>
                  {each.fileUrl && each.fileUrl.length > 0 ? <a
                    style={{
                      color: "#F58220",
                      fontWeight: 'bold',
                      cursor: "pointer",
                      textDecoration: "underline",
                      fontSize: '14px',
                    }}
                    href={each.fileUrl}
                    target="_blank"
                  >
                    Download
                  </a> :
                    each.status === "error"
                      ? <span
                        style={{
                          color: "#F58220",
                          fontSize: '14px',
                        }}
                      >
                        Erro
                      </span> :
                      <span
                        style={{
                          color: "#F58220",
                          fontSize: '14px',
                        }}
                      >
                        Carregando...
                      </span>
                  }
                </td>
              </TableRow>
            ))}
        </TableBody>
      </NewDataTable>

    </ExportsContainer>
  )
}